__turbopack_context__.v({
  "alwaysShow": "RiEpha_alwaysShow",
  "body": "RiEpha_body",
  "button": "RiEpha_button",
  "buttonContainer": "RiEpha_buttonContainer",
  "icon": "RiEpha_icon",
  "invert": "RiEpha_invert",
  "link": "RiEpha_link",
  "message": "RiEpha_message",
  "slide": "RiEpha_slide",
  "thumbsIcon": "RiEpha_thumbsIcon",
});
